module.exports = __webpack_public_path__ + "img/9788958200659.27155bd7.jpg";